import { render } from "./KitchenStats.vue?vue&type=template&id=f9fbcf4e"
import script from "./KitchenStats.vue?vue&type=script&lang=js"
export * from "./KitchenStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__